export default ({ app }) => {
  app.router.afterEach((to, from) => {
    if (typeof (window as any).pintrk === 'function') {
      (window as any).pintrk('page');
    }
  })
}
